import { createContext, ReactNode, useContext, useMemo } from 'react'
import { useLocalSearchParams } from 'expo-router'

type RouteParam = string | string[] | undefined

interface ICourseRouteParams {
  courseId: RouteParam
  enrollmentId: RouteParam
}

const CourseRouteParamsContext = createContext<ICourseRouteParams | null>(null)

export function CourseRouteParamsProvider({
  children,
  courseId,
  enrollmentId,
}: {
  children: ReactNode
  courseId: string
  enrollmentId?: string | null
}) {
  const contextValue = useMemo(
    () => ({ courseId, enrollmentId: enrollmentId ?? undefined }),
    [courseId, enrollmentId],
  )

  return (
    <CourseRouteParamsContext.Provider value={contextValue}>
      {children}
    </CourseRouteParamsContext.Provider>
  )
}

export function useCourseRouteParams(): ICourseRouteParams {
  const provided = useContext(CourseRouteParamsContext)
  const { courseId, enrollmentId } = useLocalSearchParams<{
    courseId: string
    enrollmentId: string
  }>()

  return provided ?? { courseId, enrollmentId }
}
